/* Tayga 2027 — categoría: envío gratis en tarjetas, Cotizar, Comparar (hasta 3), banner a mitad de cuadrícula, "leer más". */
(function () {
  // Más vendidos: la mancuerna camuflaje sale por decisión del dueño (la colección es automática por tipo).
  if (location.pathname.indexOf('/collections/mas-vendidos') === 0) {
    document.querySelectorAll('.grid-product').forEach(function (c) {
      if (c.querySelector('a[href*="mancuerna-hexagonal-acero-y-pvc-camuflaje"]')) c.remove();
    });
  }
  'use strict';
  var root = document.querySelector('[data-tg-col]');
  if (!root) return;
  var QUOTE = parseInt(root.getAttribute('data-quote'), 10) || 5000000;
  var MSIMIN = parseInt(root.getAttribute('data-msimin'), 10) || 150000;
  var QURL = root.getAttribute('data-quote-url') || 'mailto:ventas@tayga.mx?subject=Cotizaci%C3%B3n%20Tayga';
  var KEY = 'tg_cmp_v1';
  function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-MX'); }
  function parsePrice(el) {
    if (!el) return 0;
    var nodes = el.cloneNode(true);
    Array.prototype.forEach.call(nodes.querySelectorAll('.grid-product__price--original,.visually-hidden,.grid-product__price--savings'), function (n) { n.remove(); });
    var m = nodes.textContent.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : 0;
  }
  (function () {
    var st = document.createElement('style');
    st.textContent = '.tg-grid-extra__add{font:800 12px/1 var(--typeHeaderPrimary),\'Barlow Condensed\',sans-serif;letter-spacing:.06em;text-transform:uppercase;background:#FDB022;color:#111827;border:1.5px solid #FDB022;border-radius:4px;padding:7px 10px;cursor:pointer;text-decoration:none;white-space:nowrap;transition:filter .2s}' +
      '.tg-grid-extra__add:hover{filter:brightness(1.07);color:#111827}.tg-grid-extra__add--o{background:#fff;border-color:#111827}' +
      '.tg-grid-extra__add[disabled]{background:#e5e7eb;border-color:#e5e7eb;color:#6b7280;cursor:default}.tg-grid-extra__add.is-ok{background:#108474;border-color:#108474;color:#fff}';
    document.head.appendChild(st);
  })();
  var cmp = [];
  try { cmp = JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) {}
  function saveCmp() { try { sessionStorage.setItem(KEY, JSON.stringify(cmp)); } catch (e) {} }

  // leer más
  var more = root.querySelector('[data-tg-more]');
  if (more) more.addEventListener('click', function () {
    root.querySelector('[data-tg-intro-short]').hidden = true;
    root.querySelector('[data-tg-intro-full]').hidden = false;
  });

  function enhance() {
    var cards = document.querySelectorAll('.grid-product[data-product-handle]:not([data-tg])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-tg', '1');
      var h = card.getAttribute('data-product-handle');
      var meta = card.querySelector('.grid-product__meta') || card.querySelector('.grid-product__content');
      var price = parsePrice(card.querySelector('.grid-product__price'));
      var title = (card.querySelector('.grid-product__title') || {}).textContent || h;
      var img = card.querySelector('img');
      var box = document.createElement('div'); box.className = 'tg27 tg-grid-extra';
      var html = '';
      if (price >= 499900) html += '<div class="tg-grid-extra__msi">Envío gratis</div>';
      html += '<div class="tg-grid-extra__row"><label><input type="checkbox" data-cmp="' + h + '"' + (cmp.some(function (c) { return c.h === h; }) ? ' checked' : '') + '> Comparar</label>';
      var soldOut = !!card.querySelector('.grid-product__tag--sold-out');
      var varies = /^\s*(desde|de|from)\s/i.test((card.querySelector('.grid-product__price') || {}).textContent || '');
      var url = (card.querySelector('.grid-product__link') || {}).getAttribute ? card.querySelector('.grid-product__link').getAttribute('href') : '/products/' + h;
      if (price >= QUOTE) html += '<a class="tg-grid-extra__q" href="' + QURL + '">Cotizar</a>';
      else if (soldOut) html += '<button type="button" class="tg-grid-extra__add" disabled>Agotado</button>';
      else if (varies) html += '<a class="tg-grid-extra__add tg-grid-extra__add--o" href="' + url + '">Ver opciones →</a>';
      else html += '<button type="button" class="tg-grid-extra__add" data-add="' + h + '" data-url="' + url + '">+ Agregar</button>';
      html += '</div>';
      box.innerHTML = html;
      (card.querySelector('.grid-product__content') || card).appendChild(box);
      var add = box.querySelector('[data-add]');
      if (add) add.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        add.disabled = true; add.textContent = 'Agregando…';
        fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
          var avail = p.variants.filter(function (v) { return v.available; });
          if (avail.length !== 1) { window.location.href = add.getAttribute('data-url'); return; }
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: avail[0].id, quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function () {
              add.classList.add('is-ok'); add.textContent = '✓ Agregado';
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: p } }));
              fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
                Array.prototype.forEach.call(document.querySelectorAll('.cart-link__bubble'), function (b) { b.classList.add('cart-link__bubble--visible'); b.setAttribute('data-count', c.item_count); });
              });
              setTimeout(function () { add.disabled = false; add.classList.remove('is-ok'); add.textContent = '+ Agregar'; }, 2500);
            });
        }).catch(function () { add.disabled = false; add.textContent = 'Reintentar'; });
      });
      var cb = box.querySelector('[data-cmp]');
      cb.addEventListener('change', function () {
        if (cb.checked) {
          if (cmp.length >= 3) { cb.checked = false; alert('Puedes comparar hasta 3 productos.'); return; }
          cmp.push({ h: h, t: title.trim(), i: img ? (img.currentSrc || img.src) : '' });
        } else cmp = cmp.filter(function (c) { return c.h !== h; });
        saveCmp(); bar();
      });
    });
    // banner a mitad de cuadrícula
    var mid = root.querySelector('template[data-tg-mid]');
    var grid = document.querySelector('.grid-product') && document.querySelector('.grid-product').parentNode;
    if (mid && grid && !grid.querySelector('.tg-mid-wrap')) {
      var items = grid.querySelectorAll(':scope > .grid-product');
      var at = parseInt(mid.getAttribute('data-after'), 10) || 8;
      if (items.length > at) {
        var w = document.createElement('div'); w.className = 'grid__item one-whole tg27 tg-mid-wrap';
        w.innerHTML = mid.innerHTML; items[at - 1].after(w);
      }
    }
  }

  // barra de comparación
  var cbar = document.createElement('div'); cbar.className = 'tg27 tg-cmpbar';
  cbar.innerHTML = '<b style="font:700 15px var(--tg-h);text-transform:uppercase">Comparar</b><div data-imgs style="display:flex;gap:6px"></div><div class="tg-cmpbar__t" data-t></div><button type="button" data-clear>Limpiar</button><button type="button" class="tg-btn" data-go>Comparar ahora</button>';
  document.body.appendChild(cbar);
  var modal = document.createElement('div'); modal.className = 'tg27 tg-cmp'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
  modal.innerHTML = '<div class="tg-cmp__box"><div class="tg-cmp__head"><h2 class="tg-h" style="font-size:26px">Comparar productos</h2><button type="button" aria-label="Cerrar" data-close>×</button></div><div data-body>Cargando…</div></div>';
  document.body.appendChild(modal);
  function bar() {
    cbar.classList.toggle('is-on', cmp.length > 0);
    cbar.querySelector('[data-imgs]').innerHTML = cmp.map(function (c) { return c.i ? '<img src="' + c.i + '" alt="">' : ''; }).join('');
    cbar.querySelector('[data-t]').textContent = cmp.length + ' de 3 · ' + cmp.map(function (c) { return c.t.slice(0, 26); }).join(' vs ');
    cbar.querySelector('[data-go]').disabled = cmp.length < 2;
    cbar.querySelector('[data-go]').style.opacity = cmp.length < 2 ? .5 : 1;
  }
  cbar.querySelector('[data-clear]').addEventListener('click', function () {
    cmp = []; saveCmp(); bar();
    Array.prototype.forEach.call(document.querySelectorAll('[data-cmp]'), function (x) { x.checked = false; });
  });
  function close() { modal.classList.remove('is-on'); }
  modal.querySelector('[data-close]').addEventListener('click', close);
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  cbar.querySelector('[data-go]').addEventListener('click', function () {
    if (cmp.length < 2) return;
    modal.classList.add('is-on');
    var body = modal.querySelector('[data-body]'); body.textContent = 'Cargando…';
    Promise.all(cmp.map(function (c) {
      return fetch('/products/' + c.h + '?view=tg-compare').then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); });
    })).then(function (ps) {
      var keys = [];
      ps.forEach(function (p) { Object.keys(p.specs || {}).forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); }); });
      function row(label, fn) { return '<tr><th>' + label + '</th>' + ps.map(function (p) { return '<td>' + (fn(p) || '—') + '</td>'; }).join('') + '</tr>'; }
      var html = '<table><tr><th></th>' + ps.map(function (p) {
        return '<td><img src="' + p.img + '" alt=""><div style="font-weight:600;margin-top:6px">' + p.title + '</div></td>';
      }).join('') + '</tr>';
      html += row('Precio', function (p) { return '<b>' + money(p.price) + '</b>'; });
      html += row('Tipo', function (p) { return p.type; });
      html += row('Marca', function (p) { return p.vendor; });
      html += row('Opciones', function (p) { return p.options; });
      html += row('Disponible', function (p) { return p.available ? 'Sí' : 'Agotado'; });
      keys.forEach(function (k) { html += row(k, function (p) { return (p.specs || {})[k]; }); });
      html += row('', function (p) { return '<a class="tg-btn" href="' + p.url + '">' + (p.price >= QUOTE ? 'Ver y cotizar' : 'Ver producto') + '</a>'; });
      body.innerHTML = html + '</table>' + (keys.length ? '' : '<p style="font-size:12px;color:#6b7280;margin-top:10px">Las especificaciones técnicas detalladas se agregan con la revisión del catálogo.</p>');
    }).catch(function () { body.textContent = 'No se pudo cargar la comparación. Intenta de nuevo.'; });
  });

  enhance(); bar();
  new MutationObserver(function () { enhance(); }).observe(document.body, { childList: true, subtree: true });
})();
